import Snackbar from './SnackbarContainer';
export default Snackbar;



// WEBPACK FOOTER //
// ./src/js/Snackbars/index.js